import type { RecommendationConflict } from '@painpal/contracts';
import { PlanTag } from '../calendar/PlanTag';
import { formatEstimate } from '../calendar/planModel';
import { suggestionDuration, whyLine } from './recommendationModel';
import styles from './recommendations.module.css';

export interface SwapStripProps { conflict: RecommendationConflict; saving: boolean; onKeep: () => void; onSwap: () => void }

// The planned block stays as it is; this only offers the easier day the rules would pick. The alternative is never Rest,
// so it always has a duration and a structure.
export function SwapStrip({ conflict, saving, onKeep, onSwap }: SwapStripProps) {
  const { alternative } = conflict;
  return (
    <div className={styles.swap} role="group" aria-label="Swap suggestion">
      <p className={styles.why}><span className={styles.flag}>DOESN&apos;T FIT</span> {whyLine(conflict.reasons)}</p>
      <div className={styles.alternative}>
        <span className={styles.label}>SWAP FOR</span>
        <PlanTag type={alternative.type} outline />
        <span className={styles.quiet}>{suggestionDuration(alternative)}</span>
        <span className={styles.quiet}>{formatEstimate(alternative.estimatedLoad)} LOAD</span>
        <span className={styles.structure}>{alternative.structure}</span>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.keep} onClick={onKeep}>KEEP PLAN</button>
        <button type="button" className={styles.swapButton} disabled={saving} onClick={onSwap}>SWAP</button>
      </div>
    </div>
  );
}
